/**
 * Uses a formik component and field name to validate a specific field of that formik.
 * This formik can be passed using the useRef react hook and the innerRef property of Formik.
 * The validation schema of the formik should be appropriately set, as well as the following properties:
 * validateOnChange={false}
 * validateOnBlur={false}
 * 
 * @param {string} fieldName //The name of the formik value to be validated.
 * @param {object} formik //The formik component whose validate function you will use.
 */
export const validateSingleField = (fieldName, formik) => {
    if (formik && fieldName) {
        formik.validateField(fieldName);
        formik.setFieldTouched(fieldName, true, false);
    }
}

/**
 * Uses a formik component and list of field names to validate specific fields of that formik.
 * To prevent setting errors to fields the user has not interacted with yet,
 * it will only validate fields that have already been touched. 
 * This formik can be passed using the useRef react hook and the innerRef property of Formik.
 * The validation schema of the formik should be appropriately set, as well as the following properties:
 * validateOnChange={false}
 * validateOnBlur={false}
 * 
 * @param {Array} fieldNameList //The list of names of the formik values to be validated.
 * @param {object} formik //The formik component whose validate function you will use.
 */
export const validateTouchedFieldList = (fieldNameList, formik) => {
    fieldNameList.forEach(fieldName => {
        if(formik.touched[fieldName]) {
            validateSingleField(fieldName, formik);
        }

    });
}

/**
 * Uses a formik component and field name to remove the errors for the specified field of that formik.
 * This formik can be passed using the useRef react hook and the innerRef property of Formik.
 * 
 * @param {string} fieldName //The name of the formik value to be validated.
 * @param {object} formik //The formik component whose validate function you will use.
 */
export const resetErrorForField = (fieldName, formik) => {
    if (formik && fieldName) {
        const errorsCopy = Object.assign({}, formik.errors);
        errorsCopy[fieldName] = '';
        formik.setErrors(errorsCopy, false);
    }
}

/**
 * Uses an array of ValidationErrorDto received from RegistrationValidationController
 * to make one presentable string.
 * 
 * @param {string} errorArray // The array of errors to be formatted
 */
export const formatBackendErrors = (errorArray) => {
    let errorString = "";
    errorArray.forEach((error) => {
        if (errorString) {
            errorString += '\n';
        }
        errorString += error.defaultMessage;
    });
    return errorString;
}

/**
 * Uses an array of ValidationErrorDto received from RegistrationValidationController
 * to check if we have a specific error type.
 * 
 * @param {string} errorArray // The array of errors
 */
 export const containsErrorType = (errorArray, type) => {
    let hasType = false;
    errorArray.forEach((error) => {
        if (error.errorType == type) {
            hasType = true;
        }
    });
    return hasType;
}

/**
 * Uses an array of ValidationErrorDto received from RegistrationValidationController
 * to check get the contact Id for a specific error type.
 * 
 * @param {string} errorArray // The array of errors
 */
 export const getContactIdForErrorType = (errorArray, type) => {
    let contactId = null;
    errorArray.forEach((error) => {
        if (error.errorType == type) {
            contactId = error.contactId;
        }
    });
    return contactId;
}